import { FaTools, FaWhatsapp } from "react-icons/fa";

export const MaintenancePage = () => {
  return (
    <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-px-4">
      <div className="card card-style">
        <div className="content mt-2 mb-0">
          {/* Animated icon */}
          <div className="tw-flex tw-justify-center tw-mb-6 tw-mt-2">
            <div className="tw-relative tw-flex tw-items-center tw-justify-center tw-w-24 tw-h-24 tw-rounded-full tw-bg-yellow-100">
              <div className="tw-absolute tw-inset-0 tw-rounded-full tw-border-4 tw-border-yellow-400 tw-animate-ping tw-opacity-30" />
              <FaTools className="tw-text-yellow-500 tw-text-4xl tw-relative tw-z-10" />
            </div>
          </div>

          {/* Title */}
          <h2 className="tw-text-center tw-text-xl tw-font-extrabold tw-text-gray-800 dark:tw-text-white tw-mb-1">
            Sedang Maintenance
          </h2>

          {/* Subtitle */}
          <p className="tw-text-center tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-mb-5 tw-leading-relaxed">
            Sistem sedang dalam proses pemeliharaan. <br />
            Kami akan segera kembali!
          </p>

          <div className="divider mt-2 mb-4" />

          {/* Contact info */}
          <p className="text-center tw-text-sm tw-font-light tw-text-gray-500 mb-3">
            Silahkan hubungi{" "}
            <span className="tw-font-medium tw-text-primary-700">Admin</span>{" "}
            jika ada pertanyaan mendesak
          </p>

          <style>{`
            @keyframes progress-pulse {
              0%, 100% { opacity: 1; width: 65%; }
              50% { opacity: 0.7; width: 70%; }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};
